const inPersonGPDrugList = ["semaglutide", "liraglutide"]; //stromectol

export default inPersonGPDrugList;
